export const NEW_MANAGE_HTML_FONTSIZE = 23.4375;

export const OLD_MANAGE_HTML_FONTSIZE = 20.5;
